import React from 'react';
import Chart, { Props as ChartProps } from 'react-apexcharts';
import { merge } from 'lodash';

const ColumnChart = ({ options, ...props }: ChartProps): React.ReactElement => {
  return (
    <Chart
      options={merge(
        {
          chart: {
            animations: { enabled: props.width === '100%' },
            fontFamily: 'futura-pt',
            toolbar: { show: false },
            zoom: { enabled: false }
          }
        },
        options
      )}
      {...props}
    />
  );
};

export default ColumnChart;
